<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      返佣对账
    </p>
    <div class="search">
      <!-- 详细筛选条件 -->
      <div>
        <div
          class="search-detail"
        >
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入对账单标题"
          v-model="searchForm.title"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入税务编号"
          v-model="searchForm.invoice_no"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入物流编号"
          v-model="searchForm.logistics_no"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入流水单号"
          v-model="searchForm.flow_no"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Select
            clearable
            filterable
            class="search-input"
            :placeholder="'请选择下单时间'"
            element-id="balance_state"
            v-model="searchForm.balance_state"
          >
            <Option
              v-for="spareType in roderstateList"
              :key="spareType.id"
              :value="spareType.id"
            >{{spareType.name}}</Option>
          </Select>
        </div>
        <div class="search-detail-item">
          <DateRangePicker
            class="search-input"
            :placeholder="'请选择下单时间'"
            :value="emptyORderTime"
            @on-change="daterangeChange($event, 'balance_start_time', 'balance_end_time')"
          />
        </div>
        <div class="search-detail-item">
          <Button
            type="primary"
            class="search-button"
            @click="loadList"
          >查找</Button>
          <Button
            class="search-button"
            @click="resetSearchForm"
          >重置</Button>
        </div>
        </div>
      </div>
    </div>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
    <PicsModal
      :pics="picList"
      :visible="picModel"
      :index="picIndex"
      @on-close="picModel = false"
    />
    <ApplyBalance
    :ApplyId="ApplyId"
    :editModal="editModal"
    @callback="loadList()"
    @backeditModal= "editModal = false"
    />
   </card>
 </div>
</template>

<script>
import {mapState} from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'
import PicsModal from '@/components/PicsModal'
import ApplyBalance from './ApplyBalance'

export default {
  components: {
    DateRangePicker,
    PicsModal,
    ApplyBalance
  },
  props: {
    orderId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      ApplyId: 0,
      editModal: false,
      urlImg: '',
      picModel: false,
      picList: [],
      picIndex: 0,
      emptyORderTime: ['', ''],
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      searchForm: {
        title: '',
        balance_state: '',
        invoice_no: '',
        logistics_no: '',
        flow_no: '',
        balance_start_time: '',
        balance_end_time: ''
      },
      roderstateList: [
        {
          id: '2',
          name: '审核中'
        }, {
          id: '3',
          name: '已返佣'
        },
        {
          id: '1',
          name: '未申请'
        }
      ]
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 180,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'CheckDetail', params: { orderId: row.id } })
                }
              },
              style: {
              }
            }, ['查看详情'])
            let reEdit = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.ApplyId = row.id
                  this.editModal = true
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['申请返佣'])
            if (row.balance_state === 1) {
              return h('span', [
                check,
                reEdit
              ])
            } else {
              return h('span', [
                check
              ])
            }
          }
        },
        {
          title: '对账单标题',
          key: 'title',
          width: 180,
          ellipsis: true
        },
        {
          title: '对账单周期',
          width: 280,
          render: (h, {row}) => {
            let balanceTime = row.start_time + '到' + row.end_time
            return h('span', [balanceTime])
          }
        },
        {
          title: '返佣金额',
          key: 'balance_price',
          width: 120,
          ellipsis: true
        },
        {
          title: '返佣状态',
          width: 140,
          render: (h, {row}) => {
            let Type = ''
            if (row.balance_state === 1) {
              Type = '未申请'
            } else if (row.balance_state === 2) {
              Type = '审核中'
            } else {
              Type = '审核通过'
            }
            return h('span', [Type])
          }
        },
        {
          title: '返佣时间',
          key: 'balance_time',
          width: 140,
          ellipsis: true
        },
        {
          title: '税务编号',
          key: 'invoice_no',
          width: 140,
          ellipsis: true
        },
        {
          title: '物流编号',
          key: 'logistics_no',
          width: 140,
          ellipsis: true
        },
        {
          title: '开票凭证',
          width: 140,
          ellipsis: true,
          render: (h, {row}) => {
            let check = h('a', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.picIndex = this.index
                  this.picModel = true
                  this.urlImg = row.img_urls
                  this.showPicList(row.id)
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['查看图片'])
            return ('span', [check])
          }
        },
        {
          title: '流水单号',
          key: 'flow_no',
          width: 140,
          ellipsis: true
        },
        {
          title: '返佣凭证',
          width: 140,
          ellipsis: true,
          render: (h, {row}) => {
            let check = h('a', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.picIndex = this.index
                  this.picModel = true
                  this.urlImg = row.img_urls
                  this.showPicList(row.id)
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['查看图片'])
            return ('span', [check])
          }
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/balance/list', {
          params: {
            id: this.orderId,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            ...this.searchForm
          }
        }),

        this.$http.get('/balance/count', {
          params: {
            id: this.orderId,
            ...this.searchForm
          }
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    showPicList (index) {
      let arrImg = this.urlImg
      let arr = arrImg.split(',')
      console.log(arr)
      if (arr.length !== 0) {
        arr.forEach((item) => {
          this.picList.push(item)
        })
      }
      this.picIndex = index
      this.picModel = true
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeChange (daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0].replace('/', '-').replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyORderTime = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm () {
      this.emptyORderTime = ['', '']
      this.searchForm = {
        title: '',
        balance_state: '',
        invoice_no: '',
        logistics_no: '',
        flow_no: '',
        balance_start_time: '',
        balance_end_time: ''
      }
      this.loadList()
    },
    editReport () {
      this.editReportCurstom = true
    }
  },
  created () {
    this.$http.get('/dropdown/industry').then(res => {
      this.busType = res.data
    })
    this.$http.get('/dropdown/chargePackage').then(res => {
      this.buyPeople = res.data
    })
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/rakeBackManage/index.vue